@if (bloc$ | async; as bloc) {
  <pr-datapoint-selector
    class="flex grow"
    [label]="label"
    [dataSource]="bloc.dataSource$ | async"
    [measures]="measures$ | async"
    [datapointId]="bloc.formControls.measure?.value?.metadata?.id"
    (datapointIdChange)="handleSelect($event)"
  />
}
